import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { gql, useQuery, useApolloClient } from '@apollo/client';
import dayjs from 'dayjs';

import Page from '../../atoms/Page';
import Card from '../../atoms/Card';
import { DATE_YEAR_MONTH_DAY_DASH_TIME_HOUR_MINUTE } from '../../utils/dates';
import TextArea from '../../atoms/TextArea';
import MockBarnSetupCard from '../../organisms/MockBarnSetupCard/MockBarnSetupCard';

import './MockBarnPage.scss';
import Button from '../../atoms/Button';

const BARN_GQL = gql`
  query MockBarnDataQuery {
    barns: farm(
      where: { deleted_at: { _is_null: true }, mock_barn_simulation_setting: { settings: { _is_null: false } } }
      order_by: { created_at: desc }
    ) {
      id
      name
      organization {
        name
      }
      mock_barn_simulation_state {
        simulation_time_end
      }
      mock_barn_simulation_setting {
        settings
        version
      }
    }
  }
`;
function MockBarnPage({ titleSegments = [] }) {
  const client = useApolloClient();
  const pageTitleSegments = useMemo(() => ['Mock Barns', ...titleSegments], []);
  const { loading, error, data } = useQuery(BARN_GQL, {
    variables: {},
  });

  return (
    <Page className="MockBarnPage" titleSegments={pageTitleSegments}>
      <h2>Mock Barn Setup </h2>
      <MockBarnSetupCard />
      <h2>Mock Barns</h2>
      <Button
        content="Refresh"
        loading={loading}
        onClick={async () => {
          await client.refetchQueries({
            include: [BARN_GQL],
          });
        }}
      ></Button>
      {error && (
        <Card status="error">
          <b>Error:</b>
          <br />
          {JSON.stringify(error)}
        </Card>
      )}
      {data?.barns?.map((b) => {
        return (
          <Card key={b.id} className="barnCard">
            <h4>
              <Link to={`/b/${b.id}`}>{b.name}</Link>
            </h4>
            <br />
            <b>Organization:</b> {b?.organization?.name || 'Unknown'}
            <br />
            <b>Last Updated:</b>{' '}
            {b?.mock_barn_simulation_state?.simulation_time_end
              ? dayjs.tz(b?.mock_barn_simulation_state?.simulation_time_end * 1000).fromNow() +
                ' - ' +
                dayjs
                  .tz(b?.mock_barn_simulation_state?.simulation_time_end * 1000)
                  .format(DATE_YEAR_MONTH_DAY_DASH_TIME_HOUR_MINUTE)
              : 'Not Running'}
            <br />
            <b>Version:</b> {b?.mock_barn_simulation_setting?.version || 'Unknown'}
            <br />
            <TextArea value={JSON.stringify(b?.mock_barn_simulation_setting?.settings, null, 4)}></TextArea>
          </Card>
        );
      })}
    </Page>
  );
}

MockBarnPage.propTypes = {
  titleSegments: PropTypes.arrayOf(PropTypes.string),
};

export default MockBarnPage;
